import { api } from "./api";

const KEY = "rc_viewed_training";

function seen() {
  try { return new Set(JSON.parse(localStorage.getItem(KEY) || "[]")); } catch { return new Set(); }
}

// Registers a view for each event not yet seen in this browser. Returns { [id]: newCount }.
export async function registerTrainingViews(events) {
  const s = seen();
  const fresh = events.filter((e) => e.id && !s.has(e.id));
  const updates = {};
  for (const e of fresh) {
    try {
      const { data } = await api.post(`/training/${e.id}/view`);
      updates[e.id] = data.views;
      s.add(e.id);
    } catch (err) { console.debug("training view register failed:", err); }
  }
  if (Object.keys(updates).length) localStorage.setItem(KEY, JSON.stringify([...s]));
  return updates;
}
